<template>
  <div style="width: 100%;height: 100%;">
    <div class="curve-title">
      <div class="heart" v-if="isWarning">
        <div class="heart-left"></div>
      </div>
      <div class="m-home-head-tip">
        300p
      </div>
      {{ title }}
      <div class="curve-title-spot-top"></div>
      <div class="curve-title-spot-bottom"></div>
      <div class="curve-tips">
        <div class="curve-tips-box" v-if="tooltip !== ''">
          <el-tooltip placement="left-start">
            <div slot="content">{{ tooltip }}</div>
            <i class="el-icon-warning-outline curve-tips-i"></i>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div style="height: 3%"></div>
    <div className="proCharts" ref='charts' style="width: 100%;height: 80%;"></div>
  </div>
</template>

<script>
export default {
  name: 'Read15Date',
  props: {
    'dataJson': {
      type: Array,
      default: []
    },
    'dayList': {
      type: Array,
      default: []
    },
    'title': {
      type: String,
      default: ''
    },
    'tipsName': {
      type: String,
      default: ''
    },
    'tooltip': {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isWarning: false,
      option: {
        // color: ['rgb(8,252,7)', 'rgb(255,168,0)'],
        // title: {
        //   text: '123'
        // },
        // legend: { // 图例的类型
        //   icon: 'roundRect', // 图例icon图标
        //   data: [
        //     {
        //       name: '用户数',
        //       textStyle: {
        //         color: '#fff'
        //       }
        //
        //     }
        //   ]
        // },
        tooltip: { // 提示框
          trigger: 'axis'
        },
        grid: {
          left: '5%',
          right: '6%',
          bottom: '6%',
          top: '6%',
          containLabel: true // grid区域是否包含坐标轴的刻度标签
        },
        xAxis: {
          type: 'category', // 坐标轴类型。
          boundaryGap: false, // 坐标轴两边留白策略
          data: this.dayList,
          // data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          axisLabel: { // 坐标轴刻度标签的相关设置
            interval: 0,
            textStyle: {
              color: '#fff',
              fontSize: 12
            }
          },
          axisLine: { // 坐标轴轴线相关设置
            show: true,
            lineStyle: {
              color: 'rgb(2,121,253)'
            }
          },
          axisTick: { // 坐标轴刻度相关设置。
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: { // x轴的坐标文字
            show: true,
            textStyle: {
              color: '#fff' // 文字的颜色
            }
          },
          // max: 1000, // 最大值1000
          axisLine: { // 坐标轴轴线相关设置
            show: true,
            lineStyle: {
              color: 'rgb(2,121,253)'
            }
          },
          axisTick: { // 坐标轴刻度相关设置。
            show: false
          },
          splitLine: { // 坐标在grid区域的分割线
            lineStyle: { // 设置分割线的样式(图表横线颜色)
              color: ['#153a8a']
            }
          }
        },
        series: [
          {
            name: this.tipsName,
            type: 'line',
            data: this.dataJson,
            // data: [10, 20, 30, 40, 50, 60, 70, 80, 190],
            lineStyle: {
              color: 'rgb(8,252,7)' // 线的颜色
            }
          }
          // {
          //   name: '本年',
          //   type: 'line',
          //   data: [20, 20, 30, 50, 50, 10, 50, 20, 30, 50, 50, 30],
          //   lineStyle: {
          //     color: 'rgb(255,168,0)' // 线的颜色
          //   }
          // }
        ]
      }
    }
  },
  created () {
  },
  methods: {
    // 初始化图表
    mycharts () {
      // 获得月份数组
      // let monthArr = []
      // let date = new Date()
      // let month = date.getMonth() + 1
      // 判断报警数值，设置报警数值上限
      for (let i = 0; i < this.dataJson.length; i++) {
        if (this.dataJson[i] >= 300) {
          this.isWarning = true
        }
      }
      this.option.xAxis.data = this.dayList
      // 初始化图表
      let myChart = this.$echarts.init(this.$refs.charts, 'macarons')
      myChart.setOption(this.option)
      // 图表自适应
      window.addEventListener('resize', function () {
        myChart.resize() // myChart 是实例对象
      })
    }
  },
  mounted () {
    this.mycharts()
  }
}
</script>

<style scoped>
.curve-title {
  height: 17%;
  background-image: linear-gradient(to right, #0055bb,transparent);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f0f0f0;
  font-size: 16px;
  position: relative;
}
.curve-title-spot-top {
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 5px;
  background-color: #69aaff;
}
.curve-title-spot-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 5px;
  height: 5px;
  background-color: #69aaff;
}
.curve-tips {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 40px;
}
.curve-tips {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.curve-tips-box {

}

.curve-tips:hover .curve-tips-i{
  color: #1c9dff;
}

@keyframes beat{
  30%{transform:scale(1.3);}
  100%{transform:scale(1);}
}

.heart{
  animation:beat 1s infinite;
  position: absolute;
  left: 10px;
}

.heart-left {
  width:15px;
  height:15px;
  background-color: red;
  border-radius: 15px;
}

.m-home-head-tip {
  position: absolute;
  left: 35px;
  font-size: 14px;
  font-weight: revert;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Read_15_date.vue